module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/massage-desktop-c474bfbd661501893c5880a594cec15f.jpg";